module.exports = __webpack_public_path__ + "img/drawing@2x.52c7585.webp";